import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { _isNumberValue } from '@angular/cdk/coercion';
import { MatTableDataSource } from '@angular/material/table';
import { Role } from '../../../../models/data/identity/role';
import { UserEnvelope } from '../../../../models/net/envelope/user-envelope';
import { UserRole } from '../../../../models/data/identity/user-role';
import { ClaimType } from '../../../../models/data/identity/claim-type';
import { UserClaim } from '../../../../models/data/identity/user-claim';
import { Location } from '@angular/common';
import { UserService } from '../../../../services/identity/users/user.service';
import { EditorComponent } from '../../../base/editor/editor.component';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css', '../../../../app.component.css']
})

export class UserComponent extends EditorComponent {

    public avatarUrl: string = "";

    public displayedUserRolesColumns: string[] = ["Avatar", "Role", "Delete"];
    public displayedUserClaimsColumns: string[] = ["Avatar", "ClaimType", "ClaimValue", "Delete"];
    public userRolesDatasource: any = null;
    public availableRoles: Role[] = []
    public selectedRole: Role | null = null;
    public availableClaimTypes: ClaimType[] = [];
    public userClaimsDatasource: any = null;
    public selectedClaimType: ClaimType | null = null;
    public enteredClaimValue: string = "";

    @ViewChild("appHistory") appHistory!: HistoryComponent;

    public constructor(public override appService: AppService,
                       public override itemService: UserService, 
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "user", "users");
    }

    public override handleEditMode = (): void => {

        this.appService.navigateTo("user/" + this.itemId.toString(), "");
    }

    public override initializeEnvelope = (envelope: UserEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new UserEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);
        this.userRolesDatasource = new MatTableDataSource((this.itemEnvelope as UserEnvelope).Document.UserRoles);
        const roleIds: number[] = (this.itemEnvelope as UserEnvelope).Document.UserRoles.map((i: UserRole) => i.RoleId);
        const availableRoles: Role[] = (this.itemEnvelope as UserEnvelope).Roles.filter((i: Role) => !roleIds.includes(i.RoleId));
        this.availableRoles = this.appService.cloneObject(availableRoles);
        this.userClaimsDatasource = new MatTableDataSource((this.itemEnvelope as UserEnvelope).Document.UserClaims);
        const availableClaimTypes: ClaimType[] = (this.itemEnvelope as UserEnvelope).ClaimTypes;
        this.availableClaimTypes = availableClaimTypes;
    }

    public addSelectedRoleToUser = (): void => {

        const userRole: UserRole = {
            UserRoleId: 0,
            UserId: this.itemEnvelope?.Document?.Item?.UserId == null ? 0 : this.itemEnvelope?.Document?.Item?.UserId,
            RoleId: this.selectedRole?.RoleId == null ? 0 : this.selectedRole?.RoleId,
            CreatedOnUTC: new Date(),
            CreateUserUID: ""
        };

        (this.itemEnvelope as UserEnvelope)?.Document?.UserRoles.push(userRole);

        this.userRolesDatasource = new MatTableDataSource((this.itemEnvelope as UserEnvelope)?.Document?.UserRoles);

        const itemIndex: number = this.availableRoles.map((i: any) => i.RoleId).indexOf(this.selectedRole?.RoleId, 0);

        if (itemIndex > -1) {

            this.availableRoles.splice(itemIndex, 1);
        }

        this.selectedRole = null;
    }

    public addClaimToUser = (claimType: ClaimType | null, claimValue: string): void => {

        if (claimType) {

            const userClaim: UserClaim = {
                UserClaimId: 0,
                UserId: this.itemEnvelope?.Document?.Item?.UserId == null ? 0 : this.itemEnvelope?.Document?.Item?.UserId,
                ClaimTypeId: claimType.ClaimTypeId,
                ClaimValue: claimValue,
                CreatedOnUTC: new Date(),
                CreateUserUID: ""
            };

            (this.itemEnvelope as UserEnvelope)?.Document?.UserClaims.push(userClaim);

            this.userClaimsDatasource = new MatTableDataSource((this.itemEnvelope as UserEnvelope)?.Document?.UserClaims);

            this.enteredClaimValue = "";
            this.selectedClaimType = null;
        }
    }

    public deleteUserRole = (userRole: UserRole): void => {

        const itemIndex: number | undefined = (this.itemEnvelope as UserEnvelope)?.Document?.UserRoles.map((i: UserRole) => i.UserRoleId).indexOf(userRole.UserRoleId, 0);

        if (itemIndex != undefined && itemIndex > -1) {

            (this.itemEnvelope as UserEnvelope)?.Document?.UserRoles.splice(itemIndex, 1);
            this.userRolesDatasource = new MatTableDataSource((this.itemEnvelope as UserEnvelope)?.Document?.UserRoles);
        }

        const availableRole: Role | undefined = (this.itemEnvelope as UserEnvelope)?.Roles.find((i: Role) => i.RoleId == userRole.RoleId);

        if (availableRole) {

            this.availableRoles.push(availableRole);
        }
    }

    public deleteUserClaim = (userClaim: UserClaim): void => {

        const itemIndex: number | undefined = (this.itemEnvelope as UserEnvelope)?.Document?.UserClaims.map((i: UserClaim) => i.UserClaimId).indexOf(userClaim.UserClaimId, 0);

        if (itemIndex != undefined && itemIndex > -1) {

            (this.itemEnvelope as UserEnvelope)?.Document?.UserClaims.splice(itemIndex, 1);
            this.userClaimsDatasource = new MatTableDataSource((this.itemEnvelope as UserEnvelope)?.Document?.UserClaims);
        }
    }

    public getRoleUIDFromRoleId = (roleId: number): string => {

        let result: string = "";

        let role: Role | undefined = (this.itemEnvelope as UserEnvelope)?.Roles.find((i: Role) => i.RoleId == roleId)

        if (role) {

            result = role.UID;
        }

        return result;
    }

    public getClaimTypeUIDFromClaimTypeId = (claimTypeId: number): string => {

        let result: string = "";

        let claimType: ClaimType | undefined = (this.itemEnvelope as UserEnvelope)?.ClaimTypes.find((i: ClaimType) => i.ClaimTypeId == claimTypeId);

        if (claimType) {

            result = claimType.UID;
        }

        return result;
    }

    public onTabChange(event: MatTabChangeEvent) {

        if (event.index == 3 && !this.isRevisionListLoaded) {

            this.appHistory.searchRevisions();
        }
    }
}
